module.exports = __webpack_public_path__ + "static/project-17a-ad1621128e01c2fed0a127ed701356e5.png";